import React from "react";
import navbarBrand from "../../../assets/images/navbar-logo.svg";
import logoImg from "../../../assets/images/login-t-logo.svg";

const HeaderPage = () => {
  return (
    <header className="header d-flex justify-content-between align-items-center header text-white pt-3 px-3">
      <h4 className="fw-bold">Analytics PRO</h4>
      <div className="logo-div d-flex">
        {/* <img src={navbarBrand} alt="NavbarBrand" width={500} height={74} /> */}
        <div className="d-flex flex-column align-items-center ">
          <img src={logoImg} style={ {height: '32px',marginTop: '2px',}}></img>
          {/* <p className="fs-7">Powered by T-Systems</p> */}
        </div>
      </div>
    </header>
  );
};
export default HeaderPage;
